class hotspotSlide {
  constructor(el) {
    this.el = el;
    this.slides = this.el.querySelectorAll(".slider-btn");
    this.hotspotSlides = this.el.querySelectorAll(".hotspot-slide");

    // get the index no for active element
    this.getNodeindex = elm => [...elm.parentNode.children].indexOf(elm)

    this.navigate();
    this.hotspotPosition();
    this.hotspotPopup();
    // Mobile Device
    if (window.outerWidth < 767) {
      this.popupBaseContainer();
      this.deviceSlideOnHotspot();
      this.deviceSlideOnDot();
    }

  }



  navigate() {

    for (let i = 0; i < this.slides.length; ++i) {
      let slideno = this.slides[i];
      this.slide(slideno);
    }
  }



  slide(element) {
    let self = this;
    element.addEventListener("click", function (e) {
      e.preventDefault();
      let PerentContainer = this.closest('.hotspot-slide-section');
      let activeBtn = this.getAttribute('data-view-btn');


      PerentContainer.querySelector('.slider-btn-section .active-btn').classList.remove('active-btn');

      PerentContainer.querySelector('.hotspot-slide-container .active-slide').classList.remove('active-slide');
      this.classList.add('active-btn');
      PerentContainer.querySelector('[data-view=' + activeBtn + ']').classList.add('active-slide');

      let activeSlide = PerentContainer.querySelector('.hotspot-slide.active-slide');
      // const getNodeindex = elm => [...elm.parentNode.children].indexOf(elm)
      let ActiveSlideIndex = self.getNodeindex(activeSlide);

      self.slideBtnAnimate(PerentContainer);

    }, false);
  }

  slideBtnAnimate(parentElem) {
    let PerentContainer = parentElem;
    let activeHotspotSlideIndex = this.getNodeindex(PerentContainer.querySelector('.slider-btn-section .active-btn'));
    let slideBtnWidth = PerentContainer.querySelector(".slider-btn").offsetWidth;
    let selectedBtnSlidePos = (activeHotspotSlideIndex * slideBtnWidth);
    PerentContainer.querySelector(".tab-btn-trans").style.transform = 'translateX(' + selectedBtnSlidePos + 'px)';
  }

  hotspotPosition() {
    let hotspotSlidElm = this.hotspotSlides;
    hotspotSlidElm.forEach(function (element) {
      let hotspotItemElm = element.querySelectorAll('.hotspot-item');
      hotspotItemElm.forEach(function (elem) {
        elem.style.top = elem.getAttribute('data-top');
        elem.style.left = elem.getAttribute('data-left');
      });
    });
  }

  hotspotPopup() {
    if (window.outerWidth >= 768) {
      let hotspotEle = document.querySelectorAll('.hotspot-item');
      hotspotEle.forEach(function (element) {
        element.addEventListener("mouseover", function (e) {
          e.preventDefault();

          if (document.querySelector('.hotspot-item.active') !== null) {
            document.querySelector('.hotspot-item.active').classList.remove('active');
          }
          if (document.querySelector('.hotspot-popup.show') !== null) {
            document.querySelector('.hotspot-popup.show').classList.remove('show');
          }
          this.classList.add('active');

          let hotspotTarget = this.getAttribute('data-target');
          let popupElem = this.closest('.hotspot-slide').querySelector("[data-hotspot=" + hotspotTarget + "]");
          popupElem.style.visibility = 'hidden';
          popupElem.classList.add('show');

          let sliderContainerPadding = (document.querySelector('.gallery-section').offsetWidth - document.querySelector('.gallery-container').offsetWidth) / 2;
          // let popUpWidht = popupElem.offsetWidth;
          let hotspotWidth = getComputedStyle(this).width;
          let hotspotPopuptWidth = popupElem.offsetWidth;
          let hotspotPopuptHeight = popupElem.offsetHeight;


          let hotspotLeft;
          let hotspotTop = getComputedStyle(this).top;
          let HotspotLeftValue = parseInt(getComputedStyle(this).left) + parseInt(hotspotWidth);


          // test
          let parentElement = this.closest('.hotspot-slide').offsetWidth;
          let HotspotRight = parseInt(getComputedStyle(this).right);
          let totalval = parentElement - HotspotRight;
          let hotspotRight;
          if (hotspotPopuptWidth > totalval) {
            hotspotLeft = 'unset';
            hotspotRight = parentElement - hotspotPopuptWidth - (parseInt(getComputedStyle(this).width) / 2) + 'px';
          }
          else {
            hotspotLeft = parseInt(getComputedStyle(this).left) + sliderContainerPadding - hotspotPopuptWidth + 'px';
            hotspotRight = 'unset';
          }

          popupElem.style.top = parseInt(hotspotTop) - hotspotPopuptHeight - 12 + 'px';
          popupElem.style.left = hotspotLeft;
          // popupElem.style.left = parseInt(hotspotLeft) - hotspotPopuptWidth + 'px';
          popupElem.style.right = hotspotRight

          popupElem.style.visibility = 'unset'

        })

        element.addEventListener("mouseout", function (e) {
          e.preventDefault();

          if (document.querySelector('.hotspot-item.active') !== null) {
            document.querySelector('.hotspot-item.active').classList.remove('active');
          }
          if (document.querySelector('.hotspot-popup.show') !== null) {
            document.querySelector('.hotspot-popup.show').classList.remove('show');
          }
        })
      })
    }

  }
  popupBaseContainer() {
    let popUpSlideWidth = document.querySelector(".hotspot-popup").offsetWidth;
    let mainSlideElem = document.querySelectorAll(".hotspot-slide");


    mainSlideElem.forEach(function (element) {
      let hotspotSlideElem = element.querySelectorAll(".hotspot-popup");
      let wrapperWidth = popUpSlideWidth * hotspotSlideElem.length;

      hotspotSlideElem.forEach(function (elem) {
        elem.style.width = popUpSlideWidth + 'px';
        elem.style.maxWidth = popUpSlideWidth + 'px';


      })

      element.querySelector(".hotspot-inner-block").setAttribute('style', 'opacity: 1; width:' + wrapperWidth + 'px;  transform: translate3d(0, 0, 0);transition: transform 300ms ease 0s;');

    })


  }

  deviceSlideOnHotspot() {
    let self = this;
    let hotspotSlidesItem = document.querySelectorAll(".hotspot-item");
    for (let i = 0; i < hotspotSlidesItem.length; ++i) {

      hotspotSlidesItem[i].addEventListener("click", function (e) {
        e.preventDefault();

        let nextHotspotElem = this.getAttribute('data-target');
        let hotspotParentElem = this.closest('.hotspot-slide');

        hotspotParentElem.querySelector('.hotspot-dot.active-dot').classList.remove('active-dot');
        hotspotParentElem.querySelector('.hotspot-item.active-mob-hotspot').classList.remove('active-mob-hotspot');

        this.classList.add('active-mob-hotspot');
        hotspotParentElem.querySelector('[data-hotspot-dot=' + nextHotspotElem + ']').classList.add('active-dot');
        hotspotParentElem.querySelector('[data-hotspot=' + nextHotspotElem + ']').classList.add('active-hotspot-slide');

        self.slideAnimate(hotspotParentElem, '.hotspot-item.active-mob-hotspot');

      }, false);
    }

  }
  deviceSlideOnDot() {
    let self = this;
    let hotspotSlidesItem = document.querySelectorAll(".hotspot-dot");
    for (let i = 0; i < hotspotSlidesItem.length; ++i) {

      // hotspotSlidesItem.forEach(function (elem) {
      hotspotSlidesItem[i].addEventListener("click", function (e) {
        e.preventDefault();

        let nextHotspotElem = this.getAttribute('data-hotspot-dot');
        let hotspotParentElem = this.closest('.hotspot-slide');

        hotspotParentElem.querySelector('.hotspot-dot.active-dot').classList.remove('active-dot');
        hotspotParentElem.querySelector('.hotspot-item.active-mob-hotspot').classList.remove('active-mob-hotspot');

        this.classList.add('active-dot');

        hotspotParentElem.querySelector('[data-target=' + nextHotspotElem + ']').classList.add('active-mob-hotspot');
        hotspotParentElem.querySelector('[data-hotspot=' + nextHotspotElem + ']').classList.add('active-hotspot-slide');


        self.slideAnimate(hotspotParentElem, '.hotspot-dot.active-dot');

      }, false);
    }

  }


  slideAnimate(parentElem, element) {
    let hotspotParentElem = parentElem;
    // const getNodeindex = elm => [...elm.parentNode.children].indexOf(elm)

    let activeHotspotSlide = hotspotParentElem.querySelector(element);
    let activeHotspotSlideIndex = this.getNodeindex(activeHotspotSlide);
    let slideWidth = hotspotParentElem.querySelector(".hotspot-popup").offsetWidth;
    let selectedSlidePos = -(activeHotspotSlideIndex * slideWidth);
    hotspotParentElem.querySelector(".hotspot-inner-block").style.transform = 'translate3d(' + selectedSlidePos + 'px, 0, 0)';
  }

}

// function call

let element = document.querySelector(".hotspot-slide-section");
if (element && element != null) {
  new hotspotSlide(element);

  window.addEventListener("resize", function (e) {
    new hotspotSlide(element);
  })
}

// const dataModules = [...document.querySelectorAll('[data-module="hotspot-slide"]')];

// dataModules.forEach((element) => {
//   element.dataset.module.split(" ").forEach(function () {
//     new hotspotSlide(element);
//   });
// });